module.exports = __webpack_public_path__ + "img/zfb.9ff3edfb.png";